"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AD_ELIGIBLE_PAID_STORY_IDS = void 0;
// prettier-ignore
exports.AD_ELIGIBLE_PAID_STORY_IDS = [
    124711439,
    132168362,
    145972746,
    206445908,
    233933220,
];
